import { NOPING_GREEN, PURPLE, SILVER } from '../constants';

export function ArenaBg() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' aria-hidden='true'>
      <div className='absolute inset-0' style={{ background: `linear-gradient(180deg, ${PURPLE}30, transparent 60%)` }} />
      <div className='absolute inset-0 opacity-[0.03]' style={{ backgroundImage: `repeating-linear-gradient(0deg, transparent, transparent 60px, ${SILVER}40 60px, ${SILVER}40 61px), repeating-linear-gradient(90deg, transparent, transparent 60px, ${SILVER}40 60px, ${SILVER}40 61px)` }} />
      <div className='absolute left-1/2 top-1/4 h-[600px] w-[800px] -translate-x-1/2 rounded-full blur-[150px]' style={{ backgroundColor: `${PURPLE}20` }} />
      <div className='absolute bottom-0 left-1/2 h-[200px] w-[600px] -translate-x-1/2 rounded-full blur-[120px]' style={{ backgroundColor: `${NOPING_GREEN}08` }} />
    </div>
  );
}
